import request, { IServerResponse } from '@/utils/request';
import { GetLiveDataParams, GetOnlineUsersParams, OnlineUsersPointData } from './define';

/** 获取直播在线人数统计 */
export const getOnlineUsers = (
    params: GetOnlineUsersParams,
): Promise<IServerResponse<OnlineUsersPointData[]>> =>
    request.get('/api/live/statistics/onlineUsers', params);

/** 获取直播统计数据 */
export const getLiveData = (
    params: GetLiveDataParams,
): Promise<IServerResponse<urls.live.ILiveData>> =>
    request.get('/api/live/statistics/liveData', params);
